/* Publish by EComposer at 2025-08-01 17:48:04*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hasp3ygt067"]=  window.__ectimmers["ecom-hasp3ygt067"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-hasp3ygt067').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hasp3ygt067', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5j7bmftzgi5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5j7bmftzgi5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rdduybgi8q9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rdduybgi8q9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dtoz1st6am7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dtoz1st6am7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3d2d6afi6as').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3d2d6afi6as', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tql5b8n03e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tql5b8n03e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gbhl6g7oguh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gbhl6g7oguh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ypjc34afurr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ypjc34afurr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oulumegomlr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oulumegomlr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cfxu2ah5d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cfxu2ah5d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-szlw7650jk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-szlw7650jk', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0nsn0qmo7ed"]=  window.__ectimmers["ecom-0nsn0qmo7ed"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-0nsn0qmo7ed').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0nsn0qmo7ed', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zsg2cn382g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zsg2cn382g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d2kh0ggzg9m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d2kh0ggzg9m', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0pgpvckroqk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0pgpvckroqk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-l7yokm1kqvg"]=  window.__ectimmers["ecom-l7yokm1kqvg"] || {};
var e=this.$el;if(e&&this.isLive){var o=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");o.length&&o.forEach(function(s){var n=s.getAttribute("href")||"#",r=n.replace("{current-link}",location.href);s.setAttribute("href",r)})}

                    });
                    
                        document.querySelectorAll('.ecom-l7yokm1kqvg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l7yokm1kqvg', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qzc5x3astsa"]=  window.__ectimmers["ecom-qzc5x3astsa"] || {};
if(this.settings.layout==="slider"){let i=this.$el,t="bullets";if(this.settings.slider_pagination_style==="progress"&&(t="progressbar"),!i)return;let o=i.querySelector(".ecom-shopify__blog-container"),s=o&&o.dataset.optionSwiper;s=JSON.parse(s),s.pagination={el:i.querySelector(".ecom-swiper-pagination"),type:t,clickable:!0},s.navigation={nextEl:i.querySelector(".ecom-swiper-button-next"),prevEl:i.querySelector(".ecom-swiper-button-prev")},new window.EComSwiper(o,s)}if(this.settings.use_ajax&&this.isLive){const i=this.$el;if(!i)return;const t=i.querySelector(".ecom-shopify__blog-wrapper"),o=function(e){e.preventDefault();const a=this.dataset.get,n=this.closest(".ecom-sections[data-section-id]");if(!a||!n||!n.dataset.sectionId)return;const p=n.dataset.sectionId,_=`${a}&section_id=${p}`;c(_,n),t.scrollIntoView()};i.querySelectorAll(".ecom-pagination-item").forEach(e=>{e.addEventListener("click",o)});const c=function(e,a){const n=async function(p){return(await fetch(p,{method:"GET",cache:"no-cache",headers:{"Content-Type":"text/html"}})).text()};a.classList.add("ecom-doing-load-blog"),n(e).then(function(p){i.querySelectorAll(".ecom-shopify__blog--post").forEach(function(u){u.remove()});const d=document.createElement("div");d.innerHTML=p;const r=d.querySelector(".ecom-shopify__blog--posts");if(!r)return;const y=a.querySelector(".ecom-shopify__blog--posts"),$=a.querySelector(".ecom-pagination-navigation.ecom-collection__pagination-navigation");for(;r.firstChild;)y.appendChild(r.firstChild);r.parentNode.removeChild(r);const h=d.querySelector(".ecom-pagination-navigation.ecom-collection__pagination-navigation");h&&($.innerHTML=h.innerHTML,i.querySelectorAll(".ecom-pagination-item").forEach(v=>{v.addEventListener("click",o)}))}).finally(function(){a.classList.remove("ecom-doing-load-blog")})}}

                    });
                    
                        document.querySelectorAll('.ecom-qzc5x3astsa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qzc5x3astsa', settings: {"layout":"grid"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}